type AnalyticsScheme = string | string[] | null | undefined;
const SMART_ANALYTICS_SCHEMES = ['smart', 'videoloftexp'] as const;

const analyticsSchemeIncludes = (
    analyticsScheme: AnalyticsScheme,
    scheme: string
): boolean => {
    return Array.isArray(analyticsScheme)
        ? analyticsScheme.some((candidate) => candidate.includes(scheme))
        : Boolean(analyticsScheme?.includes(scheme));
};

export const cameraHasSmartMotionEnabled = (
    analyticsEnabled?: boolean | number | null,
    analyticsScheme?: AnalyticsScheme
): boolean => {
    return (
        Boolean(analyticsEnabled) &&
        SMART_ANALYTICS_SCHEMES.some((scheme) =>
            analyticsSchemeIncludes(analyticsScheme, scheme)
        )
    );
};
